import { render, staticRenderFns } from "./GroupTransition.vue?vue&type=template&id=21087b23&"
import script from "./GroupTransition.vue?vue&type=script&lang=js&"
export * from "./GroupTransition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports